/** The run: everything we remember about one voyage, stored anonymously at the end. */
export interface RunState {
  clientId: string;
  act: number;
  earthSeconds: number;
  shipSeconds: number;
  minR: number;
  choice: 'hold' | 'fall' | null;
  briefing: number[];
  debrief: number[];
  quality: 'cinematic' | 'fast';
}

export function newRun(): RunState {
  return { clientId: clientId(), act: 5, earthSeconds: 0, shipSeconds: 0, minR: Infinity, choice: null, briefing: [], debrief: [], quality: 'cinematic' };
}

/** A random per-browser id, kept in localStorage when that is available. Never identifies a person. */
export function clientId(): string {
  const key = 'mwv.client';
  try {
    const v = localStorage.getItem(key); if (v) return v;
    const id = randomId(); localStorage.setItem(key, id); return id;
  } catch { return randomId(); }
}

function randomId(): string {
  const a = new Uint8Array(12);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(a); else for (let i = 0; i < 12; i++) a[i] = Math.floor(Math.random() * 256);
  return Array.from(a, (b) => b.toString(16).padStart(2, '0')).join('');
}
